import { c as _c } from "react/compiler-runtime";
export interface RowTitleProps {
  title: string;
  titleUrl?: string;
  columnCount?: number;
}
const rowTitleClasses = ["text-gray-m10 font-semibold", "text-base sm:text-lg", "leading-[1.375rem] sm:leading-8", "tracking-normal sm:tracking-[0.18px]", "t2-dark:text-white"].join(" ");
const rowTitleLinkClasses = ["text-blue-trmb underline", "hover:no-underline", "focus:outline-none focus:no-underline", "t2-dark:text-yellow-m10"].join(" ");
export const RowTitle = t0 => {
  const $ = _c(8);
  const {
    title,
    titleUrl,
    columnCount
  } = t0;
  let t1;
  if ($[0] !== title || $[1] !== titleUrl) {
    t1 = titleUrl ? <a href={titleUrl} className={rowTitleLinkClasses}>{title}</a> : title;
    $[0] = title;
    $[1] = titleUrl;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <div className="min-w-full border-b border-gray-m2 t2-dark:border-b-white"><span className="sticky left-0 inline-block py-4 px-6">{t1}</span></div>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== columnCount || $[6] !== t2) {
    t3 = <tr className={rowTitleClasses}><td colSpan={columnCount}>{t2}</td></tr>;
    $[5] = columnCount;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};